import { toast } from 'react-toastify'
import { format } from 'react-string-format'

export const ToastCreateSuccessBottomLeft = (message: string) => {
  // const message = format('عملیات ثبت {0} با موفقیت انجام گردید', pageName)
  toast.success(message, {
    position: toast.POSITION.BOTTOM_LEFT,
  })
}

export const ToastUpdateSuccessBottomLeft = (pageName: string[], message: string) => {
  // const message = format('عملیات ویرایش {0} با موفقیت انجام گردید', pageName)
  toast.success(message, {
    position: toast.POSITION.BOTTOM_LEFT,
  })
}

export const ToastDeleteSuccessBottomLeft = (pageName: string, message: string) => {
  // const message = format('عملیات حذف {0} با موفقیت انجام گردید', pageName)
  toast.success(message, {
    position: toast.POSITION.BOTTOM_LEFT,
  })
}
export const ToastSuccessBottomLeft = (message: string) => {
  toast.success(message, {
    position: toast.POSITION.BOTTOM_LEFT,
  })
}

export const ToastErrorBottomLeft = (message: string) => {
  toast.error(message, {
    position: toast.POSITION.BOTTOM_LEFT,
  })
}

export const ToastsErrorBottomLeft = (messages: string[]) => {
  messages.map((message) => {
    toast.error(message, {
      position: toast.POSITION.BOTTOM_LEFT,
    })
  })
}
export const ToastsErrorTopCenter = (messages: string[]) => {
  messages.map((message) => {
    toast.error(message, {
      position: toast.POSITION.TOP_CENTER,
    })
  })
}
